// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__GDj8r","head":"Table_head__3OgC_","col":"Table_col__1jLzy"};